module.exports = __webpack_public_path__ + "img/zhizao.ccb75f45.png";